import React, { useEffect } from "react";
import { Table } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { connect } from "react-redux";
import { getUserList, doUserDelete } from "../../../../redux/user/userState";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import { handleTableChange } from "../../../../utils/index";
import ModuleSearchFilter from "components/search/ModuleSearchFilter";

const UserTable = ({ recordList, pagination, doSearch, doDelete, filters }) => {
	const { getColumnSearchProps } = ColumnSearchFilter();
  	const columns = [
		{
	        title: `Username`,
	        dataIndex: 'username',
	        key: 'username',
	        width: '12%',
	        sorter: true,
	        ...getColumnSearchProps('username'),
	        render:(username, record) => <a href={`/console/farmer-users/${record.id}/view`}>
				{username}
				</a> 	       
	    },
	    {
	        title: `First Name`,
	        dataIndex: 'user_details',
	        key: 'first_name',
	        width: '20%',
	        sorter: true,
	        ...getColumnSearchProps('first_name'),
	        render:(user_details) => <span>{user_details?.first_name}</span> 	       
	    },
		{
	        title: `Middle Name`,
	        dataIndex: 'user_details',
	        key: 'middle_name',
	        width: '20%',
	        render:(user_details) => <span>{user_details?.middle_name}</span> 	       
	    },
	    {
	        title: `Last Name`,
	        dataIndex: 'user_details',
	        key: 'last_name',
	        width: '20%',
	        sorter: true,
	        ...getColumnSearchProps('last_name'),
	        render:(user_details) => <span>{user_details?.last_name}</span> 	       
	    },
	    {
	        title: '',
	        dataIndex: 'id',
	        key: 'id',
	        width: '10%',
	        render:(id) => <CrudOption baseRoute="/console/farmer-users" recordId={id} deleteHandler={doDelete}/>
	    },
    ];

	const resetFilters = () => {
		doSearch({paginate: pagination.per_page, type: 'farmers'});
	}

  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
				<ModuleSearchFilter 
					placeholder="Search by Farmer's Name"
					searchHandler={doSearch}
					resetHandler={resetFilters}
					defaultFilters={{paginate: pagination.per_page, type: 'farmers' }}
					filters={filters}
					filterName="userList"
					pagination={pagination}
				/>
	      	
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.id}
		        	pagination={{...pagination, 
						current: pagination.current_page,
						showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
		            onChange={handleTableChange(doSearch, filters, 'userList')}  
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.user.userList?.items,
	pagination: state.user.userList?.pagination,
	filters: state.user.userList?.filters,
  	requesting: state.user.userList?.requesting,
  	error: state.user.userList?.error,
  
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getUserList(filters)),
  doDelete: (id) => dispatch(doUserDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserTable);